<template>
  <FooterLinks :heading="heading" :links="links" />
</template>

<script>
import { formatUser } from '../../utils/helpers';
import { footerLinks } from '../../data/config';
import FooterLinks from '../FooterLinks/FooterLinks';

export default {
  name: 'PageLinks',
  props: {
    user: {
      type: Object
    }
  },
  data() {
    return {
      heading: footerLinks.pageLinks.heading,
      links: []
    }
  },
  components: {
    FooterLinks
  },
  mounted() {
    this.links = this.getLinks();
  },
  methods: {
    formatUser,
    getLinks() {
      const firstId = footerLinks.pageLinks.links.length + 1

      return (this.user && Object.keys(this.user).length) ? footerLinks.pageLinks.links.concat([
        {
          id: firstId,
          target: `/user/${this.user.id}`,
          title: `${this.formatUser(this.user.username)} Account`
        },
        {
          id: firstId + 2,
          target: `/wishlist/${this.user.username}`,
          title: `${this.formatUser(this.user.username)} Wishlist`
        },
        {
          id: firstId + 3,
          target: `/herd/${this.user.username}`,
          title: `${this.formatUser(this.user.username)} Herd`
        },
        {
          id: firstId + 4,
          target: `/favorites/${this.user.username}`,
          title: `${this.formatUser(this.user.username)} Favorites`
        },
      ]) : footerLinks.pageLinks.links.concat([
        {
          id: firstId,
          target: `/login`,
          title: `Login`
        },
        {
          id: firstId + 1,
          target: `/register`,
          title: `Register`
        }
      ])
    }
  },
  watch: {
    user() {
      this.links = this.getLinks();
    }
  }
};
</script>
